import { useCallback, useEffect } from "react";
import { useStores } from "./useStores";
//import { useReporting } from "./useReporting";

import { refreshAccessToken, isTokenExpired } from "@/utils/tokenUtils";
import { usePostHog } from "posthog-js/react";
/**
 * Hook for reporting errors to the session store.
 */
export const useErrorReporter = () => {
  const { sessionStore } = useStores();
  const posthog = usePostHog();
  //const { reportError: reportErrorToAnalytics } = useReporting();

  const reportError = useCallback(
    async (errorText, errorObject = undefined, fatal = true) => {
      let accessToken = localStorage.getItem("id_token");

      if (errorObject) {
        posthog.captureException(errorObject, { errorText, fatal });
      }

      if (isTokenExpired(accessToken)) {
        console.warn("Token expired, refreshing.");
        try {
          accessToken = await refreshAccessToken();
          if (!accessToken) throw new Error("No new token received");
        } catch (error) {
          console.error("Failed to refresh access token:", error);
          window.location.href = "/";
          return;
        }
      }

      const isUnauthorized =
        errorObject?.response?.status === 401 ||
        errorText?.includes("401") ||
        errorText?.includes("Unauthorized");

      if (isUnauthorized) {
        window.location.href = "/";
        console.warn(
          "Skipping unauthorized error logging to prevent infinite loops.",
        );
        return;
      }

      sessionStore.reportError(errorText, errorObject, fatal);
      // try {
      //   await reportErrorToAnalytics({
      //     errorMessage: errorText,
      //     stackTrace: errorObject?.stack,
      //     isFatal: fatal,
      //   });
      // } catch (analyticsError) {
      //   console.error("Analytics reporting failed completely:", analyticsError);
      // }
    },
    [sessionStore],
  );

  const clearErrors = useCallback(() => {
    sessionStore.activeErrors = [];
  }, [sessionStore]);

  return {
    reportError,
    clearErrors,
  };
};

/**
 * Hook for handling GraphQL errors in React Query.
 */
export const useReactQueryErrorReporter = (
  errorMessage,
  error,
  fatal = true,
  enabled = true,
) => {
  const { reportError } = useErrorReporter();

  useEffect(() => {
    if (error && enabled) {
      reportError(errorMessage, error, fatal);
    }
  }, [error, enabled]);
};
